module.exports = __webpack_public_path__ + "img/enlarge.e7fc2a66.svg";